/**
 * @ngdoc object
 * @name billing.position_categories
 * @description
 *
 */
angular
    .module('festzelt-os.billing.position_categories', [
        'ui.router',
        //'ngListView'
    ]);

require('./position_categories-routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/position_category-factory');



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/position_categories-module.js